import {
    Stack,
    Paper,
    Typography,
    TableContainer,
    Table,
    TableHead,
    TableRow,
    TableCell,
    TableBody,
    IconButton,
} from "@mui/material";
import { BASE_IMG_URL } from "../../../constants/mainAPI";
import { getDateTimeFormat } from "../../../utils/getDateFormat";
import { DocumentData } from "../../../types/api/documents";
import ClearIcon from "@mui/icons-material/Clear";
import FileDownloadIcon from "@mui/icons-material/FileDownload";

interface IProps {
    title: string;
    documents: DocumentData[];
    onDeleteChange: (val: number) => void;
}

export const DocumentTable = ({ title, onDeleteChange, documents }: IProps) => {
    return (
        <Stack direction={"column"} gap={0.5} component={Paper}>
            {title && (
                <Typography variant="h6" p={1}>
                    {title}
                </Typography>
            )}
            <TableContainer>
                <Table
                    aria-label="report table"
                    sx={{
                        "& td": { border: "none" },
                    }}>
                    <TableHead sx={{ "& th": { fontSize: "16px", fontWeight: 700 } }}>
                        <TableRow>
                            <TableCell>Название</TableCell>
                            <TableCell align="center" sx={{ width: 200 }}>
                                Дата формирования
                            </TableCell>
                            <TableCell align="right" sx={{ width: 130 }}>
                                Скачать
                            </TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {documents?.map(({ id, name, path, created_at }) => (
                            <TableRow key={id} sx={{ border: 0 }}>
                                <TableCell sx={{ wordWrap: "break-word" }}>{name}</TableCell>
                                <TableCell align="center" sx={{ width: 200 }}>
                                    {getDateTimeFormat(created_at)}
                                </TableCell>
                                <TableCell align="center" sx={{ width: 130 }}>
                                    <Stack gap={1} direction={"row"} justifyContent={"flex-end"}>
                                        <IconButton
                                            aria-label="download-icon"
                                            size="small"
                                            href={`${BASE_IMG_URL}/${path}`}>
                                            <FileDownloadIcon />
                                        </IconButton>
                                        <IconButton
                                            aria-label="delete-icon"
                                            size="small"
                                            onClick={() => {
                                                onDeleteChange(id);
                                            }}>
                                            <ClearIcon />
                                        </IconButton>
                                    </Stack>
                                </TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            </TableContainer>
        </Stack>
    );
};
